(() => {
  if (window.wishlistCartSyncInstalled) return;
  window.wishlistCartSyncInstalled = true;

  let activeUntil = 0;
  let pending = false;
  let refreshing = false;

  let awaitingBulkConfirmation = false;
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (target.closest?.('#wl-bulk-cart')) {
      awaitingBulkConfirmation = true;
      activeUntil = 0;
    } else if (target.closest?.('#wl-confirm-cancel, #wl-confirm-close')) {
      awaitingBulkConfirmation = false;
      activeUntil = 0;
    } else if (target.closest?.('#wl-confirm-yes') && awaitingBulkConfirmation) {
      awaitingBulkConfirmation = false;
      activeUntil = Date.now() + 120000;
    } else if (target.closest?.('.wl-add-to-cart-btn')) {
      awaitingBulkConfirmation = false;
      activeUntil = Date.now() + 120000;
    }
  }, true);

  const hasWishlistItems = (body) => {
    try {
      const data = typeof body === 'string' ? JSON.parse(body) : null;
      const items = data?.items || (data ? [data] : []);
      return items.some(item => item.properties?._is_wishlist === true || item.properties?._is_wishlist === 'true');
    } catch {
      return false;
    }
  };

  const isWishlistAdd = (input, method, body) => {
    if (String(method).toUpperCase() !== 'POST') return false;
    if (!hasWishlistItems(body) && Date.now() > activeUntil) return false;
    try {
      const url = new URL(input, window.location.href);
      return url.origin === window.location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
    } catch {
      return false;
    }
  };

  function waitForConfirmationToClose() {
    const popup = document.getElementById('wl-confirm-popup');
    if (!popup?.classList.contains('active')) return Promise.resolve();
    return new Promise(resolve => {
      const finish = () => {
        observer.disconnect();
        clearTimeout(timeout);
        resolve();
      };
      const observer = new MutationObserver(() => {
        if (!popup.classList.contains('active') || !popup.isConnected) finish();
      });
      observer.observe(popup, { attributes: true, attributeFilter: ['class'] });
      // Still update the cart if the app fails to finish its modal cleanup.
      const timeout = setTimeout(finish, 15000);
    });
  }

  async function refresh() {
    pending = true;
    if (refreshing) return;
    refreshing = true;
    try {
      while (pending) {
        pending = false;
        await waitForConfirmationToClose();
        if (document.getElementById('AjaxCartForm') && typeof window.refreshCart === 'function') {
          await window.refreshCart();
        } else {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
          if (!response.ok) throw new Error('Cart refresh failed');
          const cart = await response.json();
          document.querySelectorAll('[data-header-cart-count]').forEach((element) => {
            element.textContent = cart.item_count;
          });
        }
      }
    } catch (error) {
      console.warn('Wishlist cart refresh failed', error);
    } finally {
      refreshing = false;
    }
  }

  const originalFetch = window.fetch;
  window.fetch = function (input, options) {
    const tracked = isWishlistAdd(input instanceof Request ? input.url : input,
      options?.method || (input instanceof Request ? input.method : 'GET'), options?.body);
    const request = originalFetch.apply(this, arguments);
    if (tracked) request.then((response) => {
      if (response.ok) void refresh();
    }, () => {});
    return request;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  const requests = new WeakMap();
  XMLHttpRequest.prototype.open = function (method, url) {
    requests.set(this, { method, url });
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    const request = requests.get(this);
    if (request && isWishlistAdd(request.url, request.method, arguments[0])) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) void refresh();
      }, { once: true });
    }
    return originalSend.apply(this, arguments);
  };
})();
